{
  "appTitle": "Real Estate Tracker",
  "footer": "Monitorizare anunțuri imobiliare © 2026",
  "nav": {
    "ads": "Anunțuri",
    "criteria": "Criterii",
    "mortgage": "Ipotecă",
    "scraping": "Extragere",
    "administration": "Administrare"
  },
  "userMenu": {
    "role": "Rol: {{role}}",
    "logout": "Deconectare"
  },
  "logoutDialog": {
    "title": "Deconectare",
    "message": "Sigur doriți să vă deconectați?",
    "confirm": "Deconectare"
  },
  "language": {
    "label": "Limbă",
    "en": "English",
    "fr": "Français",
    "ro": "Română"
  },
  "formatters": {
    "notAvailable": "N/D",
    "invalidDate": "Dată invalidă",
    "justNow": "chiar acum",
    "minuteAgo_one": "acum {{count}} minut",
    "minuteAgo_few": "acum {{count}} minute",
    "minuteAgo_other": "acum {{count}} de minute",
    "hourAgo_one": "acum {{count}} oră",
    "hourAgo_few": "acum {{count}} ore",
    "hourAgo_other": "acum {{count}} de ore",
    "dayAgo_one": "acum {{count}} zi",
    "dayAgo_few": "acum {{count}} zile",
    "dayAgo_other": "acum {{count}} de zile",
    "weekAgo_one": "acum {{count}} săptămână",
    "weekAgo_few": "acum {{count}} săptămâni",
    "weekAgo_other": "acum {{count}} de săptămâni",
    "monthAgo_one": "acum {{count}} lună",
    "monthAgo_few": "acum {{count}} luni",
    "monthAgo_other": "acum {{count}} de luni",
    "yearAgo_one": "acum {{count}} an",
    "yearAgo_few": "acum {{count}} ani",
    "yearAgo_other": "acum {{count}} de ani",
    "roomStudio": "0,5 camere (studio)",
    "room_one": "{{count}} cameră",
    "room_few": "{{count}} camere",
    "room_other": "{{count}} de camere",
    "today": "astăzi",
    "yesterday": "ieri"
  },
  "priceDisplay": {
    "tooltip": "Prețul s-a schimbat de la {{previous}} la {{current}} ({{when}})"
  },
  "aria": {
    "menu": "meniu",
    "accountMenu": "meniul contului"
  },
  "errors": {
    "forbiddenTitle": "403 - Interzis",
    "forbiddenMessage": "Nu aveți permisiunea de a accesa această pagină.",
    "notFound": "404 - Pagina nu a fost găsită"
  },
  "status": {
    "new": "Nou",
    "not_interested": "Neinteresat",
    "interested_to_visit": "Interesat pentru vizionare",
    "visit_scheduled": "Vizionare programată",
    "visited": "Vizionat",
    "discarded": "Respins",
    "interested_to_buy": "Interesat pentru cumpărare",
    "bought": "Cumpărat",
    "retired": "Retras — nu mai este disponibil"
  },
  "actions": {
    "save": "Salvează",
    "cancel": "Anulează",
    "delete": "Șterge",
    "edit": "Editează",
    "close": "Închide",
    "confirm": "Confirmă",
    "back": "Înapoi",
    "retry": "Reîncearcă"
  }
}
